import { Injectable } from '@angular/core';
import { BrandingSettingsRequest } from '@src/app/shared/backend/clients';

@Injectable({ providedIn: 'root' })
export class ThemeService {

  constructor() { }

  async loadTheme(branding: BrandingSettingsRequest, companyName: any): Promise<void> {

    // stylesheet helper, i.e html[data-company="dentsu-tracking"]
    if (companyName) {
      const name = companyName.toLowerCase().replace(/\s+/g, '-');
      document.documentElement.setAttribute('data-company', name);
    }

    // 2. To-DO: backend should return a branding key with all the theme settings (branding?.primaryColor, branding?.secondaryColor, branding?.logoUrl...)

    const setCssProperty = (property: string, value: string) => {
      document.documentElement.style.setProperty(property, value);
    };

    // Mapping of branding props to CSS vars
    const cssVariableMappings = {
      primaryColour: [
        '--ri-bg-modal',
        '--ri-spinner-top-stroke',
        '--ri-sidebar-active-item-bg'
      ],
      primaryAccentColour: [
        '--ri-modal-title',
        '--ri-spinner-text',
        '--ri-btn-primary-accent',
      ],
      primaryBtnColour: [
        '--ri-btn-primary',
        '--ri-border-dark',
        '--ri-avatar-bg',
      ],
      primaryBtnTextColour: [
        '--ri-btn-primary-text',
        '--ri-avatar-text'
      ],
      primaryBtnHoverColour: [
        '--ri-btn-primary-hover'
      ],
      primaryBtnHoverTextColour: [
        '--ri-btn-primary-hover-text'
      ],
      secondaryAccentColour: [
        '--ri-modal-title',
      ],
      secondaryBtnColour: [
        '--ri-btn-secondary'
      ],
      secondaryBtnTextColour: [
        '--ri-btn-secondary-text'
      ],
      secondaryBtnHoverColour: [
        '--ri-btn-secondary-hover'
      ],
      secondaryBtnHoverTextColour: [
        '--ri-btn-secondary-hover-text'
      ],
      backgroundColour: [
        '--ri-bg-primary'
      ],
      headerBackgroundColour: [
        '--ri-topbar-bg'
      ],
      mainWrapperBackgroundColour: [
        '--ri-main-content-wr-bg'
      ],
      mainWrapperPaddingTop: [
        '--ri-main-content-wr-pt'
      ],
      mainWrapperPaddingRight: [
        '--ri-main-content-wr-pr'
      ],
      mainWrapperPaddingBottom: [
        '--ri-main-content-wr-pb'
      ],
      mainWrapperPaddingLeft: [
        '--ri-main-content-wr-pl'
      ],
      tableHeaderBackgroundColour: [
        '--ri-table-header-bg'
      ]
    };

    // Iterate over the mapping and set CSS props
    for (const [brandingProperty, cssVariables] of Object.entries(cssVariableMappings)) {
      const value = branding[brandingProperty as keyof BrandingSettingsRequest];
      if (value) {
        cssVariables.forEach(cssVariable => {
          setCssProperty(cssVariable, value);
        });
      }
    }

  }
}
